import { render, staticRenderFns } from "./FileFormField.vue?vue&type=template&id=4079c7b7&"
import script from "./FileFormField.vue?vue&type=script&lang=js&"
export * from "./FileFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports